import type { Core } from '@strapi/types';
import { useMutation } from '@tanstack/react-query';

import { checkIfUserViewedLastNoteApi, setUserViewedNoteApi } from '../api/release-notes.api';

export const useReleaseNotesApi = () => {
	const checkIfUserViewedLastNote = useMutation({
		mutationKey: ['[POST]:CHECK_IF_USER_VIEWED_LAST_NOTE'],
		mutationFn: (body: Core.Helpers.Controllers.GetRequestBody<'api::release-note.release-note', 'checkIfUserViewedLastNote'>) => {
			return checkIfUserViewedLastNoteApi(body);
		},
	});

	const setUserViewedNote = useMutation({
		mutationKey: ['[POST]:SET_USER_VIEWED_NOTE'],
		mutationFn: (body: Core.Helpers.Controllers.GetRequestBody<'api::release-note.release-note', 'setUserViewedNote'>) =>
			setUserViewedNoteApi(body),
	});

	const isPending = checkIfUserViewedLastNote.isPending || setUserViewedNote.isPending;
	const error = checkIfUserViewedLastNote.error || setUserViewedNote.error;

	return {
		checkIfUserViewedLastNote,
		setUserViewedNote,
		error,
		isPending,
	};
};
